import { useEffect, useState, type RefObject } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "../../../../convex/_generated/api";
import { observeFocusedMessage } from "./messageViewObserver";

type Reader = { principalId: string; name: string; firstViewedAt: number };
export function ReadReceiptDetails({ readers, truncated }: { readers: Reader[]; truncated: boolean }) {
  return <div style={{ marginTop: 6, padding: "10px 12px", border: "1px solid var(--border, #bcc7d1)", borderRadius: 6, maxWidth: 410, fontSize: 12 }}>
    {readers.length === 0 ? <p>No recorded views yet.</p> : <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
      {readers.map(reader => <li key={reader.principalId} style={{ display: "flex", flexWrap: "wrap", gap: "4px 16px", justifyContent: "space-between", padding: "4px 0" }}>
        <strong>{reader.name}</strong><time dateTime={new Date(reader.firstViewedAt).toISOString()}>{new Date(reader.firstViewedAt).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" })}</time>
      </li>)}
    </ul>}
    {truncated ? <p>Showing up to 500 recorded readers.</p> : null}
    <p style={{ margin: "8px 0 0", opacity: 0.85 }}>First shown in a focused Yodl window. This is separate from acknowledgement. Earlier views are not reconstructed.</p>
  </div>;
}

export function MessageReadReceipts({ messageId, messageElement }: { messageId: string; messageElement: RefObject<HTMLElement | null> }) {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const recordView = useMutation(api.readReceipts.viewed);
  const result = useQuery(api.readReceipts.list, visible || open ? { messageId } : "skip");
  useEffect(() => {
    const element = messageElement.current;
    if (!element) return;
    return observeFocusedMessage(element, () => recordView({ messageId }), setVisible);
  }, [messageId, messageElement, recordView]);
  const count = result?.readers.length;
  return <div style={{ marginTop: 8 }}>
    <button type="button" className="thread-link" aria-expanded={open} onClick={() => setOpen(value => !value)} title="Recorded views, with the first recorded time for each person">
      {count === undefined ? "Read receipts" : count === 0 ? "No recorded reads yet" : `Read by ${count}${result?.truncated === true ? "+" : ""} ${count === 1 ? "person" : "people"}`}
    </button>
    {open ? result === undefined ? <p role="status">Loading read receipts…</p> : <ReadReceiptDetails readers={result.readers} truncated={result.truncated} /> : null}
  </div>;
}
